import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { ProjectObjectsPage } from '@/pages/project-objects';
import { SORT_BY_DIRECTION, SORT_BY_VALUES } from '@/utils/sortTypes';
export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/objects'
)({
  component: ProjectObjectsPage,
  validateSearch: zodValidator(
    z.object({
      view: fallback(z.enum(['grid', 'list']).optional(), 'list'),
      search: fallback(z.string().optional(), ''),
      filters: z.record(z.unknown()).optional(),
      sort: fallback(
        z
          .object({
            by: z.enum(SORT_BY_VALUES),
            order: z.enum(SORT_BY_DIRECTION),
          })
          .optional(),
        undefined
      ),
    })
  ),
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="estates" /> },
});
